import { render, staticRenderFns } from "./latestNotification.vue?vue&type=template&id=b33374ee"
import script from "./latestNotification.vue?vue&type=script&lang=js"
export * from "./latestNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports